module.exports = __webpack_public_path__ + "static/WordPress-a1ee32249a87728451e0c8c3859cf067.png";